__turbopack_context__.v({
  "accordionSlideOverwrite": "slider-module-scss-module__x2PKvq__accordionSlideOverwrite",
  "container": "slider-module-scss-module__x2PKvq__container",
  "fadeIn": "slider-module-scss-module__x2PKvq__fadeIn",
  "fadeOut": "slider-module-scss-module__x2PKvq__fadeOut",
  "scaleIn": "slider-module-scss-module__x2PKvq__scaleIn",
  "scaleOut": "slider-module-scss-module__x2PKvq__scaleOut",
  "slider": "slider-module-scss-module__x2PKvq__slider",
  "zoomIn": "slider-module-scss-module__x2PKvq__zoomIn",
  "zoomOut": "slider-module-scss-module__x2PKvq__zoomOut",
});
